/*
Create By: Amit Gupta
Created On: 14/Aug/2020
rurl: pass redirection url, If URL Like /forecast/deepdive, /forecast/deepdive/1 
queryParamMap: pass query string url, If URL Like   /forecast/deepdive?id=1
NewWindow: true, false for opening in new window, Default is true

Call Function
NavigateAssociates("/forecast/deepdive","",false)
NavigateAssociates("/forecast/deepdive/1","",false)
NavigateAssociates("/forecast/deepdive","?id=1",false)   
*/

import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { UtilsService } from '../services/utils.service';


@Injectable({
	providedIn: 'root'
})

export class NavigateAssociates {

	constructor(private router: Router) {
		this.router = router;
	}

	MatchNotFoundError = "Mapping not exists.";

	navigateTO(rurl: string, queryParamMap: string = "", NewWindow: boolean = true) {
		let absoluteUrl = rurl;
		queryParamMap = queryParamMap.trim();

		let parmLst = rurl.split("?")
		if (parmLst.length > 0) {
			for (let index = 0; index < parmLst.length; index++) {
				if (index != null) {
					if (index == 0) {
						absoluteUrl = parmLst[0];
					}
					else if (queryParamMap != null && queryParamMap != "") {
						queryParamMap += "&" + parmLst[index];
					}
					else {
						queryParamMap += "?" + parmLst[index];
					}
				}
			}
		}

		let routers: Router = this.router;

		if (document.getElementsByTagName('base') != null
			&& document.getElementsByTagName('base')[0] != null
			&& document.getElementsByTagName('base')[0].href != null) {
			absoluteUrl = document.getElementsByTagName('base')[0].href + routers.createUrlTree([absoluteUrl]);
			absoluteUrl = absoluteUrl.replace(document.getElementsByTagName('base')[0].href + "/", document.getElementsByTagName('base')[0].href);
		}

		if (NewWindow) {
			window.open(absoluteUrl + queryParamMap, '_blank');
		}
		else {
			window.open(absoluteUrl + queryParamMap);
		}

	}

	jumpToNavigateTO(pageRelativeUrl: string, pageSchema: string, id: string, NewWindow: boolean = true) {
		let absoluteUrl = `/${pageRelativeUrl}`;
		let querystring = "";
		id = UtilsService.getURLHelper(UtilsService.getURLHelperDeconding(id));
		if (pageSchema == 'fc'
			&& pageRelativeUrl == '/forecast/detailed-postings'
		) {
			querystring = `?id=${id}`;
		}
		else if (pageSchema == 'st') {
			querystring = `?id=${id}`;
		}
		else if (pageSchema == 'eso'
			&& (
				pageRelativeUrl == '/eso/network-deep-dive'
				|| pageRelativeUrl == '/eso/detailed-postings'
				|| pageRelativeUrl == '/eso/deep-dive'
				|| pageRelativeUrl == '/general/network-deep-dive-map'
			)
		) {
			querystring = `?productId=${id}`;
		}
		else {
			querystring += `?id=${id}`;
		}
		let routers: Router = this.router;
		if (document.getElementsByTagName('base') != null
			&& document.getElementsByTagName('base')[0] != null
			&& document.getElementsByTagName('base')[0].href != null) {
			absoluteUrl = document.getElementsByTagName('base')[0].href + routers.createUrlTree([absoluteUrl]);
			absoluteUrl = absoluteUrl.replace(document.getElementsByTagName('base')[0].href + "/", document.getElementsByTagName('base')[0].href);
		}
		if (NewWindow) {
			window.open(absoluteUrl + querystring, '_blank');
		}
		else {
			window.open(absoluteUrl + querystring);
		}
	}


	public generateUrl(pageRelativeUrl: string, pageSchema: string, id: any): string {
		let rurl = `/${pageRelativeUrl}`;
		id = UtilsService.getURLHelper(UtilsService.getURLHelperDeconding(id));
		if (pageSchema == 'fc'
			&& pageRelativeUrl == '/forecast/detailed-postings'
		) {
			rurl += `?id=${id}`;

			return rurl;
		}
		else if (pageSchema == 'st') {
			rurl += `/${id}`;

			return rurl;
		}
		else if (pageSchema == 'eso'
			&& (
				pageRelativeUrl == '/eso/network-deep-dive'
				|| pageRelativeUrl == '/eso/detailed-postings'
				|| pageRelativeUrl == '/eso/deep-dive'
			)
		) {
			rurl += `?productId=${id}`;

			return rurl;
		}

		return rurl + `?id=${id}`;
	}
}
